/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { LinkedInAccountMiniAccountType } from './linkedInAccountMiniAccountType';
import type { LinkedInAccountMiniStatus } from './linkedInAccountMiniStatus';

/**
 * The connected LinkedIn account a LinkedIn task would execute with.
 *
 * Resolved like the executor does: the task's pinned account when it is
 * still connected, else the assignee's currently-connected account.
 * ``None`` on the detail means nothing is connected — the task can only
 * be completed outside Arbi (or skipped).
 */
export interface LinkedInAccountMini {
  id: string;
  display_name?: string | null;
  linkedin_handle?: string | null;
  account_type?: LinkedInAccountMiniAccountType;
  status: LinkedInAccountMiniStatus;
}
